module.exports = __webpack_public_path__ + "img/ime_icon_white.a7cddbf9.svg";